import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "preloader-container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "letters" }
const _hoisted_4 = { class: "progress-container" }
const _hoisted_5 = { class: "percentage" }

import { ref, onMounted, onUnmounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PreLoader',
  setup(__props) {

const letters = ['E', '-', 'G', 'C', 'R'];
const progress = ref(0);
let interval: number;

onMounted(() => {
  interval = setInterval(() => {
    if (progress.value >= 100) {
      clearInterval(interval);
    } else {
      progress.value++;
    }
  }, 20);
});

onUnmounted(() => {
  if (interval) clearInterval(interval);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bg-orbs" }, [
      _createElementVNode("div", { class: "orb orb-1" }),
      _createElementVNode("div", { class: "orb orb-2" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(letters, (letter, index) => {
          return _createElementVNode("span", {
            key: index,
            style: _normalizeStyle({ animationDelay: `${index * 0.1}s` })
          }, _toDisplayString(letter), 5)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "progress-bar",
          style: _normalizeStyle({ width: `${progress.value}%` })
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "shimmer" }, null, -1)
        ]))], 4)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(progress.value) + "%", 1)
    ])
  ]))
}
}

})